import { btn } from '../ui'
import { SheetFab } from '../SidePanel'

// Phones' way into the Taken sidebar (desktop has the rail: TakenPanel.tsx).
// The floating wine "Taken · N" button opens it as a sheet, like the
// composer's Thoughts button. Signed out, a slim bar under it keeps the Join
// CTA in view. Both mark themselves so toasts rise above them (reader.css).

/** Height of the signed-out Join bar, without the safe area. */
export const JOIN_BAR_HEIGHT = 52

/** The floating "Taken · N" button. `overBar` lifts it above the Join bar. */
export function TakenFab({ count, overBar, onOpen }: { count: number; overBar: boolean; onOpen: () => void }) {
  return (
    <SheetFab data-taken-fab="" aria-haspopup="dialog" lift={overBar ? JOIN_BAR_HEIGHT : 0} onClick={onOpen}>
      Taken · {count.toLocaleString()}
    </SheetFab>
  )
}

/** Signed out, on phones: "Take with you · Join Burrow" stays in view (design 4b's bar, slimmed). */
export function JoinBar({ taken, onJoin }: { taken: boolean; onJoin: () => void }) {
  return (
    <div
      role="region"
      aria-label="Take with you"
      data-bottom-bar=""
      className="fixed inset-x-0 bottom-0 z-30 border-t border-border/60 bg-canvas/95 pb-[env(safe-area-inset-bottom)] font-sans text-[13px] font-medium backdrop-blur-[8px]"
    >
      <div className="mx-auto flex h-[52px] w-full max-w-[816px] items-center justify-between gap-3 px-4">
        <span className="min-w-0 truncate text-muted-foreground">{taken ? 'Keep what you take' : 'Select a line to take it'}</span>
        <button type="button" onClick={onJoin} className={`${btn.primary} shrink-0`}>
          <span>
            <span className="hidden min-[400px]:inline">Take with you · </span>Join Burrow
          </span>
        </button>
      </div>
    </div>
  )
}
